import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M4 10h13v1H4v-1z'],
  height: 20,
  width: 20,
});
